// extracted by mini-css-extract-plugin
export default {"rowHover":"TableStyles_rowHover__QASt1"};